import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMidiComponent } from './simple-icons-midi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMidiComponent ],
    exports:      [ SimpleIconsMidiComponent ],
    bootstrap:    []
})
export class SimpleIconsMidiModule {}
